var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',_vm._b({class:_vm.mainExpression == 'Edit' ? 'text-center' : null},'h4',_vm.attributesBinding,false),[(
        _vm.currentField.file &&
        _vm.currentField.file.fileUrl &&
        _vm.mainExpression !== 'Edit'
      )?_c('v-btn',{staticClass:"mb-1",attrs:{"fab":"","color":"warning","width":"25","height":"25"}},[_c('v-icon',{attrs:{"size":"20","small":""}},[_vm._v("fas fa-volume-up")])],1):_vm._e(),_c('span',{class:{
        'ml-1':
          _vm.currentField.file &&
          _vm.currentField.file.fileUrl &&
          _vm.mainExpression !== 'Edit',
      }},[_vm._v(_vm._s(_vm.currentField.value.ja ? _vm.currentField.value.ja : _vm.currentField.text))])],1),(_vm.mainExpression == 'Preview' && _vm.isLanguage !== 'ja')?_c('p',{staticClass:"ma-0 text-caption",class:{
      'ml-7':
        _vm.currentField.file &&
        _vm.currentField.file.fileUrl &&
        _vm.mainExpression !== 'Edit',
    }},[_vm._v(" "+_vm._s(_vm.captionText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }